import { FeatureMouseInteraction } from '@openlayers/interaction/FeatureMouseInteraction';
import { MapOverlays } from '@openlayers/ol-overlays';
import { setMapCursor } from '@openlayers/ol-utils';
import { StringlinesLayer } from '@openlayers/stringlines/StringlinesLayer';
import { mapUI } from '@pages/map/map';
import { ProjectCodesService } from '@shared/services/ProjectCodesService';
import { jsonToHtml } from '@shared/utils/utils-html';
import Feature from 'ol/Feature';


/**
 * @author NikolaV
 */
export class StringlineDesktopMouseInteraction extends FeatureMouseInteraction<StringlinesLayer> {

    onClick = (feature: Feature, e, n): void => {
        let props = feature.get('data').props;
        ['terrainCodingDesc', 'surfaceCodingDesc', 'infraCodingDesc', 'proprietaryInfraCodingDesc'].forEach(desc => {
            if (props.hasOwnProperty(desc)) {
                props[desc] = ProjectCodesService.getDescription(props[desc]) ?? props[desc]
            }
        })
        const treeNode = mapUI.mapPanels.panels.models.tree.getById(feature.get('source').modelId);
        if (treeNode) {
            props = {
                [kuura.getMessage('tablet.filename_js')]: treeNode.text,
                ...props
            };
        }

        if (!$.isEmptyObject(props)) {
            MapOverlays.showDialog(this.map, '<div class="right"><i class="iki iki-cross" onclick="mapUI.hideDialog()"></i></div>' + jsonToHtml(props), e, n);
        }
    };

    onMouseOver = (feature: Feature, e, n): void => {
        setMapCursor(this.map, 'pointer');
    };
}
